import { Box, BoxProps } from '@ff-it/ui';
import type { RadioClip } from '../types';
import { ClipBadge } from './ClipBadge';
import { ReactElement } from 'react';

export function ClipLabel({
  clip,
  hideLength,
  ...props
}: { clip: RadioClip; hideLength?: boolean } & BoxProps): ReactElement {
  return (
    <Box display="inline-flex" alignItems="center" gap="1" textSize="sm" {...props}>
      <ClipBadge clip={clip} />
      {clip.name && <span>{clip.name}</span>}
      {!hideLength && (
        <Box textSize="xs" color="gray500">
          {clip.length_seconds}s
        </Box>
      )}
    </Box>
  );
}
